import { render } from "./Section_Plot.vue?vue&type=template&id=1ec8f5f6"
import script from "./Section_Plot.vue?vue&type=script&lang=js"
export * from "./Section_Plot.vue?vue&type=script&lang=js"

import "./Section_Plot.vue?vue&type=style&index=0&id=1ec8f5f6&lang=scss"
script.render = render

export default script